import { render, staticRenderFns } from "./WhatsEventsDialog.vue?vue&type=template&id=5624c18a"
import script from "./WhatsEventsDialog.vue?vue&type=script&lang=js"
export * from "./WhatsEventsDialog.vue?vue&type=script&lang=js"
import style0 from "./WhatsEventsDialog.vue?vue&type=style&index=0&id=5624c18a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports